import dynamicLoading from './dynamicLoading';

const install = function (Vue) {
  Vue.directive('dynamicLoading', dynamicLoading);
};

if (window.Vue) {
  window.dynamicLoading = dynamicLoading;
  Vue.use(install); // eslint-disable-line
}

dynamicLoading.install = install;
export default dynamicLoading;
